import moment from 'moment'
import {SEVERITY_LEVELS} from '../constants/StatusConstants'

let helperFunctions: any = {}

helperFunctions.generateBillingReportCode = (
  readingCount: number,
  totalTimeSpent: string,
  codeToCheck: string
): boolean => {
  const timeTracked = moment.duration(totalTimeSpent).asMinutes()
  const codes: string[] = []

  if (readingCount >= 16) codes.push('CPT 99454')
  if (timeTracked >= 20) codes.push('CPT 99457')

  // CPT 99458 is only valid if time beyond 20 mins exists in multiples of 20
  if (timeTracked > 20) {
    const additionalMinutes = timeTracked - 20
    const additionalUnits = Math.floor(additionalMinutes / 20)
    if (additionalUnits >= 1) codes.push('CPT 99458')
  }
  if (timeTracked < 20) codes.push('CPT 99458')

  return codeToCheck ? codes.includes(codeToCheck) : false
}

//TODO::Typo fix and use a language checker and dont have such mistakes
helperFunctions.getDefautSettings = (patientId : Number ) => {
  const defaultSettings = [
    // SYSTOLIC PRESSURE (TelemetryType ID 1)
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.LOW,
      min_value: 0,
      max_value: 90,
      telemetry_type_id: 1,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.NORMAL,
      min_value: 91,
      max_value: 119,
      telemetry_type_id: 1,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.ELEVATED,
      min_value: 120,
      max_value: 129,
      telemetry_type_id: 1,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPER_TENSION_STAGE_01,
      min_value: 130,
      max_value: 139,
      telemetry_type_id: 1,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPER_TENSION_STAGE_02,
      min_value: 140,
      max_value: 180,
      telemetry_type_id: 1,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPERTENSIVE_CRISIS,
      min_value: 181,
      max_value: 220,
      telemetry_type_id: 1,
      is_general_settings: false,
    },

    // DIASTOLIC PRESSURE (TelemetryType ID 2)
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.LOW,
      min_value: 0,
      max_value: 60,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.NORMAL,
      min_value: 61,
      max_value: 79,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.ELEVATED,
      min_value: 61,
      max_value: 79,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPER_TENSION_STAGE_01,
      min_value: 80,
      max_value: 89,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPER_TENSION_STAGE_02,
      min_value: 90,
      max_value: 120,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
    {
      created_by_user_id: patientId,
      patient_id: patientId,
      severity: SEVERITY_LEVELS.HYPERTENSIVE_CRISIS,
      min_value: 121,
      max_value: 180,
      telemetry_type_id: 2,
      is_general_settings: false,
    },
  ];
  const TELEMETRY_TYPES: Record<number, {
    id: number;
    name: string;
    unit: string;
    DeviceType: { id: number; name: string };
  }> = {
    1: { id: 1, name: "systolic_pressure", unit: "mmHg", DeviceType: { id: 1, name: "BP Monitor" } },
    2: { id: 2, name: "diastolic_pressure", unit: "mmHg", DeviceType: { id: 1, name: "BP Monitor" } },
  };

  return defaultSettings.map((setting, index) => ({
    id: 1000 + index, // arbitrary id to mimic DB
    created_by_user_id: patientId,
    patient_id: patientId,
    min_value: setting.min_value,
    max_value: setting.max_value,
    severity: setting.severity.value, // as string
    TelemetryType: TELEMETRY_TYPES[setting.telemetry_type_id],
  }));
};

export default helperFunctions
